<!-- Rendered once by App.vue; components show it by mounting LoadingOverlayComponent. -->
<template>
  <Transition name="fade">
    <div v-if="isLoadingOverlayShown" class="loading-overlay">
      <!-- One status region for both spinners: the logo's alt or the ring's hidden label is its text. -->
      <div class="loading-spinner" role="status">
        <img
          v-if="!whiteLabel"
          src="@/assets/img/logo/soldera-loading.svg"
          :alt="$t('common.loading')"
          class="spinner"
        />
        <div v-else class="spinner-border text-primary brand-spinner">
          <span class="visually-hidden">{{ $t("common.loading") }}</span>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { isWhiteLabel } from "@/branding";
import { isLoadingOverlayShown } from "@/composables/useLoadingOverlay";

// The spinner asset is the Soldera mark; white-label brands get a
// neutral ring in the brand's primary color.
const whiteLabel = isWhiteLabel();
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(
    var(--phoenix-body-bg-rgb),
    0.7
  ); /* Dim the background */
  backdrop-filter: blur(2px); /* Slight blur effect */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Ensure it's above other content */
}

.loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
}

.spinner {
  width: 90px;
  height: 90px;
  animation: spin 1.5s linear infinite;
}

.brand-spinner {
  width: 64px;
  height: 64px;
  border-width: 6px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
